import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import './layout.css';
import { Link, withRouter } from 'react-router-dom';
import _ from 'lodash';

class LayoutTopbar extends React.Component {
    handleFirebaseAuthSignOut = () => {
        this.props.FirebaseAuthSignOut();
    };

    componentDidMount() {
        const { LanguageChange, location } = this.props;
        let url = location.pathname.slice(1, 3).toUpperCase();
        if (url == 'EN') LanguageChange(url);
        else {
            LanguageChange('TH');
            this.handleChagePathname('TH');
        }
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.currentLanguage, this.props.currentLanguage)) {
            this.handleChagePathname(this.props.currentLanguage);
        }
    }

    handleChagePathname = (lang) => {
        document.documentElement.lang = lang.toLowerCase();
        const { history, location } = this.props;
        const { pathname, search } = location;
        if (lang == 'EN') pathname.slice(1, 3) != 'en' && history.replace(`/en${pathname}${search}`);
        else pathname.slice(1, 3) == 'en' && history.replace(pathname.slice(3) + search);
    }

    render() {
        const { firebaseAuth, OpenDialogLogin, LanguageChange, currentLanguage, wording } = this.props;

        return (
            <div className='top-bar hidden-xs'>
                <div className='container'>
                    <div className='row'>
                        <div className='top-bar-links'>
                            <ul className='col-sm-5 top-bar-currency-language'>
                                <li className='language white'>
                                    {`${wording.homePage.topbar.language} : `}
                                    <a className='pointer'>
                                        {currentLanguage === 'TH'
                                            ? wording.homePage.topbar.thai
                                            : wording.homePage.topbar.english}
                                        <i className='fa fa-angle-down white' />
                                    </a>
                                    <div className='language-dropdown'>
                                        <ul>
                                            <li>
                                                <a className='pointer' onClick={() => LanguageChange('TH')}>
                                                    {wording.homePage.topbar.thai}
                                                </a>
                                            </li>
                                            <li>
                                                <a className='pointer' onClick={() => LanguageChange('EN')}>
                                                    {wording.homePage.topbar.english}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                            <ul className='col-sm-6 col-sm-offset-1 top-bar-acc text-right top-bar-currency-language'>
                                {firebaseAuth ? (
                                    <>
                                        <li className='top-bar-link'>
                                            <a className='pointer'>
                                                {firebaseAuth.displayName
                                                    ? firebaseAuth.displayName
                                                    : firebaseAuth.email}
                                            </a>
                                            <div className='currency-dropdown'>
                                                <ul className='user-menu-item'>
                                                    <li>
                                                        <Link to='/user/address'>{wording.homePage.topbar.myAddress}</Link>
                                                    </li>
                                                    <li>
                                                        <Link to='/user/purchase'>{wording.homePage.topbar.myOrder}</Link>
                                                    </li>
                                                    <li>
                                                        <Link to='/user/return'>{wording.homePage.topbar.myReturn}</Link>
                                                    </li>
                                                    <li>
                                                        <Link to='/user/voucher'>{wording.homePage.topbar.myVoucher}</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li className='top-bar-link'>
                                            <a className='pointer' onClick={this.handleFirebaseAuthSignOut}>
                                                {wording.homePage.topbar.SignOut}
                                            </a>
                                        </li>
                                    </>
                                ) : (
                                    <>
                                        <li className='top-bar-link'>
                                            <Link to='/user/purchase' className='pointer'>{wording.homePage.topbar.checkStatusOrder}</Link>
                                        </li>
                                        <li className='top-bar-link pointer'>
                                            <a className='pointer' onClick={OpenDialogLogin}>
                                                {wording.homePage.topbar.loginRegister}
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ login, language }) => ({
    firebaseAuth: login.firebaseAuth,
    isAuthenticated: login.isAuthenticated,
    currentLanguage: language.currentLanguage,
    wording: language.wording
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            OpenDialogLogin: Actions.OpenDialogLogin,
            FirebaseAuthSignOut: Actions.FirebaseAuthSignOut,
            LanguageChange: Actions.LanguageChange
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LayoutTopbar));
